import React, { useEffect } from 'react';

const HandleMenuFocus = () => {
  useEffect(() => {
    if (window.innerWidth < 1280) {
      const menuItems = document.body.querySelectorAll(
        '.hamburger-wrapper button.hamburger--collapse.is-active, .iv--mobile-menu-header .iv--logo a, .iv--mobile-menu-header .social-header a, .iv--mobile-menu-header .iv--newsletter-link a, .iv--main-navigation .ui.pointing.secondary.menu .item',
      );
      const lastItem = menuItems[menuItems.length - 1];

      lastItem.addEventListener('keydown', (e) => {
        if (e.keyCode === 9) {
          //tab
          e.preventDefault();
          document
            .querySelector(
              '.hamburger-wrapper button.hamburger--collapse.is-active',
            )
            .focus();
        }
      });
    }
    // return () => document.body.removeEventListener('click', clickListener);
  }, []);
  return <></>;
};

export default HandleMenuFocus;
